import { render, staticRenderFns } from "./AdminLabor.vue?vue&type=template&id=380c71bc&"
import script from "./AdminLabor.vue?vue&type=script&lang=js&"
export * from "./AdminLabor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports